import { render, staticRenderFns } from "./DeodorizerTest.vue?vue&type=template&id=83c69bc2&scoped=true"
import script from "./DeodorizerTest.vue?vue&type=script&lang=js"
export * from "./DeodorizerTest.vue?vue&type=script&lang=js"
import style0 from "./DeodorizerTest.vue?vue&type=style&index=0&id=83c69bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c69bc2",
  null
  
)

export default component.exports